import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { Browser } from '@/helpers/composables/useUserAgent';
import { getPrimeShortName } from '@/helpers/promotion-helper';
import { useExperiment } from '@/libraries/experiment';
import { computed } from 'vue';

export interface PPSwiperRule {
	packages: { id: string; shortName: string; offerCountry?: string; placement: 'ft' | 'sqtv' }[];
	slideDelay: number;
	rules: {
		selectors: {
			browsers: Browser[];
			geoLocations: string[];
		};
		id: string;
	}[];
	default: {
		id: string;
	};
}

const variantPlacementMap = {
	variant_1: { placements: ['ft', 'sqtv'], delay: 1500 },
	variant_2: { placements: ['ft', 'sqtv'], delay: 3000 },
	variant_3: { placements: ['ft', 'sqtv'], delay: 5000 },
	variant_4: { placements: ['ft', 'sqtv'], delay: 7000 },
	variant_5: { placements: ['sqtv', 'ft'], delay: 2000 },
} as const;

export function usePPSwiperExp() {
	const { country } = useLanguageStore();
	const { activeVariantWithControlGroup } = useExperiment('PP_SWIPER_EXP_3');

	const shortName = computed(() => getPrimeShortName(country.value));

	function setPPSwiperExpTags(url: ClickoutUrl, placement: 'ft' | 'sqtv' = 'ft') {
		if (!activeVariantWithControlGroup.value || ![9, 119].includes(url.providerId || 0)) return url;

		const variantShort =
			activeVariantWithControlGroup.value === 'control'
				? 'ct'
				: activeVariantWithControlGroup.value.replace('variant_', 'v');

		const tag = `pps3-${country.value.toLowerCase()}-${placement}-${variantShort}-21`;

		return url.set('uct_ctag', tag);
	}

	function getPPSwiperConfig(): PPSwiperRule | null {
		if (!activeVariantWithControlGroup.value || activeVariantWithControlGroup.value === 'control') {
			return null;
		}

		return {
			packages: [
				{
					id: 'prime_0',
					shortName: shortName.value,
					placement: variantPlacementMap[activeVariantWithControlGroup.value]?.placements[0],
				},
				{
					id: 'prime_1',
					shortName: shortName.value,
					placement: variantPlacementMap[activeVariantWithControlGroup.value]?.placements[1],
				},
			],
			slideDelay: variantPlacementMap[activeVariantWithControlGroup.value]?.delay,
			rules: [],
			default: {
				id: 'prime_1',
			},
		};
	}
	return {
		getPPSwiperConfig,
		setPPSwiperExpTags,
	};
}
